import { render } from "./PopupScroll.vue?vue&type=template&id=1f00a6fe&scoped=true&ts=true"
import script from "./PopupScroll.vue?vue&type=script&lang=ts"
export * from "./PopupScroll.vue?vue&type=script&lang=ts"

import "./PopupScroll.vue?vue&type=style&index=0&id=1f00a6fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f00a6fe"]])

export default __exports__